import React from "react";

function TermsOfUse() {
  return (
    <div className="container">
      <h1>Vokab - TERMS OF USE AGREEMENT</h1>

      <p>
        Welcome to Vokab: Language Learning App ("the App"). The following Terms
        of Use ("Agreement") constitute a legal agreement between you and Vokab
        , the owner and operator of the App. By accessing or using the App, you
        agree to be bound by this Agreement.
      </p>

      <h2>1. Use of the App</h2>

      <p>
        The App is provided to you for your personal, non-commercial use. You
        may not use the App for any unlawful purpose or in any way that could
        damage, disable, overburden, or impair the App. You may not use any
        automated system, software, or device to extract data from the App
        without the prior written consent of the Company.
      </p>

      <h2>2. In-App Purchases and Subscription</h2>

      <p>
        The App may include in-app purchases and subscription services ("the
        Services"). You must have a valid payment method on file with the App
        Store in order to purchase or subscribe to the Services. Your use of the
        Services is subject to the terms and conditions of the App Store. The
        Company is not responsible for any charges or fees incurred as a result
        of the Services.
      </p>

      <h2>3. Account Creation</h2>

      <p>
        In order to use certain features of the App, you may be required to
        create an account. You must provide accurate and complete information
        when creating your account. You are solely responsible for maintaining
        the confidentiality of your account information and for all activities
        that occur under your account. The Company reserves the right to
        terminate your account at any time for any reason without notice.
      </p>

      <h2>4. Content</h2>

      <p>
        The content on the App, including but not limited to text, graphics,
        images, and software, is owned by the Company or its licensors and is
        protected by copyright and other intellectual property laws. You may not
        copy, modify, distribute, or use any of the content except as expressly
        authorized by the Company.
      </p>

      <h2>5. User Content</h2>

      <p>
        You may submit content to the App, including but not limited to
        comments, reviews, and feedback. By submitting content, you grant the
        Company a non-exclusive, royalty-free, perpetual, and irrevocable
        license to use, modify, and distribute the content for any purpose.
      </p>

      <h2>6. Disclaimer of Warranties</h2>

      <p>
        The App is provided "as is" and the Company makes no representations or
        warranties of any kind, express or implied, regarding the App or the
        content on the App. The Company disclaims all warranties, including but
        not limited to the implied warranties of merchantability, fitness for a
        particular purpose, and non-infringement.
      </p>

      <h2>7. Limitation of Liability</h2>

      <p>
        In no event shall the Company be liable for any direct, indirect,
        incidental, special, or consequential damages arising out of or in
        connection with the use of the App or the content on the App. This
        limitation
      </p>
    </div>
  );
}

export default TermsOfUse;
